import React, { useState, useEffect } from "react";
import axios from "axios";
import {  useNavigate } from "react-router-dom";

function SocioForm({onSuccess}) {
    const [formData, setFormData] = useState({
        rut: "", nombre: "", apellido: "", telefono: "", email: "",
        tipo_socio: "", zona: "", region: "", comuna: "", direccion: "",
        fecha_nacimiento: "", 
        fecha_inicio_socio: new Date().toISOString().split("T")[0], 
        fecha_oficializacion: new Date().toISOString().split("T")[0],
        oficio: "", status: "", notas: "", diocesis:"", familia: ""
    });
    

    const [zonas, setZonas] = useState([]);
    const [regiones, setRegiones] = useState([]);
    const [comunas, setComunas] = useState([]);
    const [tipo_socio, setTipos] = useState([]);
    const [status, setStatus] = useState([]);
    const [diocesis, setDiocesis] = useState([]);
    const [familias, setFamilias] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [zonasResponse, tiposResponse, statusResponse] = await Promise.all([
                    axios.get("http://192.168.1.81:5000/backend/api/zonas"),
                    axios.get("http://192.168.1.81:5000/backend/api/tipos"),
                    axios.get("http://192.168.1.81:5000/backend/api/status")
                ]);
                setZonas(zonasResponse.data);
                setTipos(Array.isArray(tiposResponse.data) ? tiposResponse.data : []);
                setStatus(Array.isArray(statusResponse.data) ? statusResponse.data : []);
            } catch (error) {
                console.error("Error al obtener datos iniciales", error);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (!formData.zona) return;
        const fetchRegiones = async () => {
            try {
                const response = await axios.get(`http://192.168.1.81:5000/backend/api/regiones?zona=${formData.zona}`);
                setRegiones(response.data);
            } catch (error) {
                console.error("Error al obtener regiones", error);
            }
        };
        fetchRegiones();
    }, [formData.zona]);

    useEffect(() => {
        if (!formData.zona) return;
        const fetchDiocesis = async () => {
            try {
                const response = await axios.get(`http://192.168.1.81:5000/backend/api/diocesis?zona=${formData.zona}`);
                setDiocesis(response.data);
            } catch (error) {
                console.error("Error al obtener diocesis", error);
            }
        };
        fetchDiocesis();
    }, [formData.zona]);

    useEffect(() => {
        if (!formData.region) return;
        const fetchComunas = async () => {
            try {
                const response = await axios.get(`http://192.168.1.81:5000/backend/api/comunas?region=${formData.region}`);
                setComunas(response.data);
            } catch (error) {
                console.error("Error al obtener comunas", error);
            }
        };
        fetchComunas();
    }, [formData.region]);

    useEffect(() => {
        if (!formData.diocesis) return;
        const fetchFamilias = async () => {
            try {
                const response = await axios.get(`http://192.168.1.81:5000/backend/api/familias?diocesis=${formData.diocesis}`);
                setFamilias(response.data);
            } catch (error) {
                console.error("Error al obtener familias", error);
            }
        };
        fetchFamilias();
    }, [formData.diocesis]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData({ 
            ...formData, 
            [name]: type === "number" ? Number(value) : value ,
            [name]: type === "text" ? value.toUpperCase() : value 
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post("http://192.168.1.81:5000/backend/api/socios", formData);
            alert("Formulario enviado correctamente");
            navigate("/mostrar");
            if (onSuccess) onSuccess();
            console.log(response.data);
        } catch (error) {
            console.error("Error al enviar el formulario", error);
            alert("Error al enviar formulario");
        }

    };

    return (
        <div className="container mt-5">
            <div className="card shadow-lg">
                <div className="card-body">
                    <h2 className="card-title text-center mb-4">Registro de Socio</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="row g-3">
                            {Object.keys(formData).map((key) => (
                                <div key={key} className="col-md-6">
                                    <label className="form-label">
                                        {key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
                                    </label>
                                    {["tipo_socio", "zona", "region", "comuna", "status", "diocesis", "familia"].includes(key) ? (
                                        <select name={key} value={formData[key]} onChange={handleChange} className="form-select" >
                                        <option value="">Seleccione una opción</option>
                                        {(key === "tipo_socio" ? tipo_socio : key === "zona" ? zonas : key === "region" ? regiones : key === "comuna" ? comunas : key === "diocesis" ? diocesis : key === "familia" ? familias : status)
                                            .filter(item => item.id) // Asegura que los elementos tengan un id
                                            .map(item => (
                                                <option key={`${key}-${item.id}`} value={item.id}>{item.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    ) : (
                                        <input type={key.includes("fecha") ? "date" : "text"} name={key} value={formData[key]} onChange={handleChange} className="form-control"  />
                                    )}
                                </div>
                            ))}
                        </div>
                        <button type="submit" className="btn btn-primary w-100 mt-3">Enviar</button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default SocioForm;
